import React from 'react';
import { motion } from 'framer-motion';
export const Proof = () => {
  return <section className="py-20 bg-cream" data-id="element-198">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-199">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-200">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center text-forest" data-id="element-201">
            Lo que cambia en 7 días
          </h2>

          <div className="space-y-8 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-amber/30 before:to-transparent" data-id="element-202">
            {/* Day 3 */}
            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-203">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-cream bg-amber text-white font-bold shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-sm z-10" data-id="element-204">
                3
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-6 rounded-2xl bg-white shadow-sm border border-cream-dark ml-4 md:ml-0" data-id="element-205">
                <h4 className="font-serif font-bold text-xl mb-2 text-amber-dark" data-id="element-206">
                  Día 3
                </h4>
                <p className="text-charcoal-light leading-relaxed" data-id="element-207">
                  Notarás que la rigidez en tus manos desaparece y tu digestión
                  se vuelve silenciosa.
                </p>
              </div>
            </div>

            {/* Day 7 */}
            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-208">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-cream bg-forest text-white font-bold shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-sm z-10" data-id="element-209">
                7
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-6 rounded-2xl bg-white shadow-sm border border-cream-dark ml-4 md:ml-0" data-id="element-210">
                <h4 className="font-serif font-bold text-xl mb-2 text-forest" data-id="element-211">
                  Día 7
                </h4>
                <p className="text-charcoal-light leading-relaxed" data-id="element-212">
                  Tus niveles de energía serán constantes, sin los bajones de la
                  tarde que antes te obligaban a buscar azúcar o café.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};